import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from "tailwind-variants"

export const styles = tv({
  slots: {
    locationTab: 'py-2 flex items-center justify-between border-t-[0.15rem] border-white list-none',
    stepContent: 'absolute top-0 left-0 max-h-full grid grid-cols-4 self-center gap-2 max-w-[65rem] transition-opacity duration-500 ease-in-out',
    locationPopup: 'absolute bottom-[20px] left-0 right-0 flex space-x-2 items-center pointer-events-none z-20 min-w-[48rem] max-w-[50rem] bg-white p-1 rounded-[1.8rem] items-stretch -translate-x-[40%]',
  },
})

export type LocationVariants = VariantProps<typeof styles>